// extracted by mini-css-extract-plugin
export var divider = "_or-0";
export var systemMessage = "_or-1";